var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122779",
    "data-name": "Group 122779",
    transform: "translate(-0.029)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(0.029)",
    fill: "#1b4a83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-business-center",
    "data-name": "Icon material-business-center",
    d: "M8.68,13.731v-.71H3.717l-.007,2.84a1.415,1.415,0,0,0,1.42,1.42h9.941a1.415,1.415,0,0,0,1.42-1.42v-2.84h-4.97v.71Zm7.1-6.391H12.934V5.92L11.514,4.5H8.673L7.253,5.92V7.34H4.42A1.424,1.424,0,0,0,3,8.76v2.13a1.415,1.415,0,0,0,1.42,1.42H8.68v-1.42h2.84v1.42h4.26a1.424,1.424,0,0,0,1.42-1.42V8.76A1.424,1.424,0,0,0,15.781,7.34Zm-4.26,0H8.68V5.92h2.84Z",
    transform: "translate(3.653 3.109)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.e4e3fa7cab1065e76f2af9b385416e4a.svg";
export { ForwardRef as ReactComponent };